export default __webpack_public_path__ + "f11d09702fe27b85b985f7a7a1405f79.png";